import React, {useState} from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {IconPlus} from "@tabler/icons-react";
import {menuItemsInfo} from "../editMenuItems";
import {CreateVariableModal} from "../settings/CreateVariableModal";
import {UI, rgba} from "../../uiTokens";
import {VarAssignmentCard} from "./VarAssignmentCard";

export const VarsTab = ({node, onUpdate, project, flow}) => {
  const {primary, secondary} = menuItemsInfo.vars;
  const [open, setOpen] = useState(false);
  const [selectedVar, setSelectedVar] = useState(null);
  const variableOptions = (project?.flow_variables?.[flow?.id] || []).map(v => v.replace(/^flow\./, ""));

  const params = node?.data?.params || [];

  const openEditor = (param = null) => {
    setSelectedVar(param);
    setOpen(true);
  };

  return (
    <>
      <CreateVariableModal
        open={open}
        variableOptions={variableOptions}
        handleClose={() => {
          setOpen(false);
          setSelectedVar(null);
        }}
        project={project}
        editParam={selectedVar}
        isForm={!!node?.data?.form_id}
        onUpdateParams={(newParams) => {
          const newNode = {...node};
          newNode.data.params = newParams || [];
          onUpdate(newNode);
        }}
        params={params}
      />

      <Box>
        <Stack direction="row" alignItems="center" gap={1}>
          <Box sx={{flex: 1}}>
            <Typography sx={{fontWeight: 700, fontSize: 14, color: UI.ink}}>{primary}</Typography>
            <Typography sx={{mt: 0.25, fontSize: 12, color: UI.muted, lineHeight: 1.45}}>{secondary}</Typography>
          </Box>
          <Button
            size="small"
            startIcon={<IconPlus size={15}/>}
            onClick={() => openEditor(null)}
            sx={{
              flexShrink: 0,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "8px",
              color: UI.accent,
              "&:hover": {backgroundColor: rgba(UI.accent, 0.1)},
            }}
          >
            Add
          </Button>
        </Stack>
      </Box>

      {params.length === 0 ? (
        <Box
          sx={{
            p: 2,
            borderRadius: "10px",
            border: `1px dashed ${rgba(UI.ink, 0.15)}`,
            textAlign: "center",
          }}
        >
          <Typography sx={{fontSize: 12, color: UI.muted}}>No variables set on this node.</Typography>
          <Button
            size="small"
            startIcon={<IconPlus size={14}/>}
            onClick={() => openEditor(null)}
            sx={{mt: 0.5, textTransform: "none", fontWeight: 600, color: UI.accent}}
          >
            Add a variable
          </Button>
        </Box>
      ) : (
        <Stack gap={1}>
          {params.map((param, index) => (
            <VarAssignmentCard
              key={`${param.uid}-${index}`}
              param={param}
              onEdit={() => openEditor(param)}
            />
          ))}
        </Stack>
      )}
    </>
  );
};
